export const GET_CARDS_LIST_API = "/api/cards/list";
export const EDIT_CARD_API = "/api/cards/edit";
export const ADD_CARD_API = "/api/cards/add";